import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// document.addEventListener('DOMContentLoaded', () => {
//   platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
// });

document.addEventListener('DOMContentLoaded', () => {
  const configUrl = 'assets/app.config.json';
  fetch(configUrl)
    .then(r => r.ok ? r.json() : Promise.resolve({}))
    .catch((err: any) => { console.warn('app.config.json could not be loaded, using defaults.', err); return {}; })
    .then((cfg: Partial<typeof environment>) => {
      if (cfg.APIUrl)         { environment.APIUrl         = cfg.APIUrl; }
      if (cfg.cookname)       { environment.cookname       = cfg.cookname; }
      if (cfg.isheaderbanner !== undefined) { environment.isheaderbanner = cfg.isheaderbanner; }
      if (cfg.istranslate    !== undefined) { environment.istranslate    = cfg.istranslate; }
      if (cfg.customerId     !== undefined) { environment.customerId     = cfg.customerId; }
    })
    .finally(() => {
      platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch(err => console.log(err));
    });
});